import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import VirtualizedContent from './VirtualizedContent';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  oddRow: {
    background: '#303f9f',
    color: 'white'
  },
  evenRow: {
    background: 'white',
    color: '#303f9f'
  }
}));

function VirtualizedTable({ data, columns, getItemSize, ...props }) {
  const header = (
    <Grid container direction="row" key="header" wrap="nowrap">
      {columns.map(column => (
        <Grid item key={column.key} xs={column.width}>
          <span>
            <Typography variant="h5" key={column.key}>
              {column.name}
            </Typography>
          </span>
        </Grid>
      ))}
    </Grid>
  );
  const classes = useStyles();
  const rowRenderer = input => {
    const { index, style } = input;
    const row = data[index];
    return (
      <Grid container direction="row" wrap="nowrap" key="content" style={style}>
        {columns.map(column => (
          <Grid
            item
            key={column.key}
            xs={column.width}
            className={index % 2 ? classes.oddRow : classes.evenRow}
          >
            <span>
              <Typography variant="h6" key={column.key}>
                {column.render(null, row)}
              </Typography>
            </span>
          </Grid>
        ))}
      </Grid>
    );
  };
  return data && data.length > 0 ? (
    <VirtualizedContent
      data={data}
      header={header}
      headerHeight={50}
      rowHeight={50}
      rowRenderer={rowRenderer}
      getItemSize={getItemSize}
    />
  ) : (
    <VirtualizedContent
      data={[]}
      // header={header}
      headerHeight={50}
      rowHeight={50}
      rowRenderer={rowRenderer}
      getItemSize={getItemSize}
    />
  );
}

export default VirtualizedTable;
